import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "dstore-service/v1/api/cms/dstore/product/";

export default {
    getCategories: function() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "categories", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getAdvanceSearch: function() {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "option/columns",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getProducts: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "list/" + param.page,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getAvailableProductKeyStocks: function(param) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "simple/view/stock/" + param.uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    saveSimpleProduct: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "simple/create",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    updateProductVisibility: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "inventory/update/visibility/" + param.uuid,
                param.param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getProduct: function(param) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "simple/view/" + param.uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    updateSimpleProduct: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "simple/update/" + param.uuid,
                param.updates,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    deleteProduct: function(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(
                BASE_SERVICE_URL + "simple/delete/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    saveVariableProduct: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "variable/create",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    updateVariableProduct: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "variable/update/" + param.uuid,
                param.updates,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    }
};
